import { createRouter, createWebHashHistory, createWebHistory, } from 'vue-router';
import Layout from '@vab/layouts/index.vue';
import { setupPermissions } from './permissions';
import { authentication, isHashRouterMode, publicPath } from '@/config';
export const constantRoutes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login/index.vue'),
        meta: {
            hidden: true,
        },
    },
    {
        path: '/callback',
        name: 'Callback',
        component: () => import('@/views/callback/index.vue'),
        meta: {
            hidden: true,
        },
    },
    {
        path: '/404',
        name: '404',
        component: () => import('@/views/404.vue'),
        meta: {
            hidden: true,
        },
    },
];
export const asyncRoutes = [
    {
        path: '/',
        name: 'Root',
        component: Layout,
        meta: {
            title: '首页',
            icon: 'home-2-line',
            breadcrumbHidden: true,
        },
        children: [
            {
                path: 'index',
                name: 'Index',
                component: () => import('@/views/index/index.vue'),
                meta: {
                    title: '首页',
                    icon: 'home-2-line',
                    noClosable: true,
                },
            },
        ],
    },
    {
        path: '/error',
        name: 'Error',
        component: Layout,
        meta: {
            title: '错误页',
            icon: 'error-warning-line',
            levelHidden: true,
        },
        children: [
            {
                path: '403',
                name: 'Error403',
                component: () => import('@/views/403.vue'),
                meta: {
                    title: '403',
                    icon: 'error-warning-line',
                },
            },
            {
                path: '404',
                name: 'Error404',
                component: () => import('@/views/404.vue'),
                meta: {
                    title: '404',
                    icon: 'error-warning-line',
                },
            },
        ],
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/404',
        name: 'NotFound',
        meta: {
            hidden: true,
        },
    },
];
const router = createRouter({
    history: isHashRouterMode
        ? createWebHashHistory(publicPath)
        : createWebHistory(publicPath),
    routes: constantRoutes,
});
function fatteningRoutes(routes) {
    return routes.flatMap((route) => {
        return route.children ? fatteningRoutes(route.children) : route;
    });
}
function addRouter(routes) {
    routes.forEach((route) => {
        if (!router.hasRoute(route.name))
            router.addRoute(route);
        if (route.children)
            addRouter(route.children);
    });
}
export function resetRouter(routes = constantRoutes) {
    routes.map((route) => {
        if (route.children)
            route.children = fatteningRoutes(route.children);
    });
    router.getRoutes().forEach(({ name }) => {
        router.hasRoute(name) &&
            router.removeRoute(name);
    });
    addRouter(routes);
}
export function setupRouter(app) {
    if (authentication === 'intelligence')
        addRouter(asyncRoutes);
    setupPermissions(router);
    app.use(router);
    return router;
}
export default router;
